import gql from 'graphql-tag';

export const VERIFY_EMAIL = gql`
  mutation VerifyEmail($credential: verifyEmailInput) {
    verifyEmail(credential: $credential) {
      email
    }
  }
`;
